/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { isPortalV2 } from '../../utility/commonUtility';

export const HEADING = 'To call Blue Yonder APIs, you must be able to uniquely identity your app to Blue Yonder.You can use this screen to add an app with a client ID and secret.';
export const AUTOCOMPLETE_PLACEHOLDER = 'Associate Machine with Roles';
export const MACHINE_NAME_LABEL = 'Machine Name';
export const CLIENT_ID = 'Client ID';
export const MACHINE_CATEGORY_TYPE = 'Machine Category Type';
export const MACHINE_TYPE = 'Machine Type';
export const SUBJECT_ID = 'Subject ID';
export const CLIENT_SECRET_TITLE = 'Client Secret';
export const CLIENT_SECRET_SUBTITLE = 'A machine can have up to two secrets at any time. Each one has its own expiration settings.';
export const CLIENT_SECRET_SUBTITLE_PORTALV2 = 'A machine can have one secret at any time. But you can rotate it to create a new one.';
export const SECRET_MONTH_NAME = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const CLIENT_SECRET_TEXT = 'Here’s your Client Secret';
export const CLIENT_SECRET_PARAGRAPH = 'Make sure to copy it. You won’t see it again.';
export const ADD_CLIENT_SECRET = 'Add Client Secret';
export const TENANT_NAME = "{Tenant Name}";
export const B2C_DOMAIN = "{B2C Domain}";

export const DELETE_CLIENT_SECRET_TITLE = 'Delete Client Secret?';
export const DELETE_CLIENT_SECRET_MESSAGE = 'Are you sure you want to delete this client secret';
export const DELETE_CLIENT_SECRET_BUTTON = 'Delete Client Secret';
export const CANCEL_BUTTON = 'Cancel';
export const DELETE_CLIENT_SECRET_SUCCESS = "Client secret deleted successfully";
export const DELETE_CLIENT_SECRET_FAILURE = "Client secret deletion failed";
export const MACHINE_NAME = 'machineName';
export const MACHINE_NAME_HAS_BEEN_UPDATED_TO = 'Machine name has been updated to';
export const ALLOWED_REALMS = 'This machine client can be used to call Blue Yonder APIs in the following realms.';
export const EDITOR = 'To execute APIs using this machine, generate an access token to register this machine in the LIAM service (see sample below).';
export const EDITOR_TOPICS = 'Use this command to generate an access token required for authenticating with event topics. Replace placeholders with your credentials.';
export const COMMAND_COPIED_TO_CLIPBOARD = 'Command copied to clipboard';
export const MACHINE_TYPE_SNOWFLAKE_CAPITAL = 'SNOWFLAKE';
export const MACHINE_TYPE_SNOWFLAKE_LOWER = 'snowflake';
export const SNACKBAR_ALERT_DEFAULT_PROPS = {
  showSnackbar: true,
  autoHideDuration: 5000,
  message: '',
  severity: 'success' as 'success' | 'error'
};

export const COPY_IDS = {
  clientId: 'clientId',
  subjectId: 'subjectId',
  tokenRequest: 'tokenRequest',
};

export const SETTINGS = 'Settings';
export const REALMS = 'Allowed Realms';
export const API_SUBSCRIPTIONS = 'API Subscriptions';
export const URI = 'URI';
export const MODULE_KEY = 'Module Key';
// PORTALV2 Uber machine type then only show Allowed Realms tab
// PORTALV2 API_SUBSCRIPTIONS TBD
export const TABS = [SETTINGS, ...(!isPortalV2() ? [REALMS] : []), ...(isPortalV2() ? [API_SUBSCRIPTIONS] : [])];
export const ADD_SUBSCRIPTION = 'Add Subscription';
export const UNSUBSCRIBE = 'Unsubscribe';
export const SELECTED = 'Selected APIs';
export const EMPTY_HEADER = 'No APIs subscribed yet';
export const EMPTY_TEXT = `Click ${ADD_SUBSCRIPTION} button to subscribe APIs for the machine`;
export const NAME = 'API Name';
export const MODULE = 'Module';
export const API_VERSION = 'Version';
export const MAX_SUBSCRIPTION_SELECTION = 20;
export const RESTRICTION_MESSAGE = `${MAX_SUBSCRIPTION_SELECTION} is the maximum limit for APIs to unsubscribe`;
export const RESTRICTION_MESSAGE_NEW = `You can select up to ${MAX_SUBSCRIPTION_SELECTION} records at a time to unsubscribe. For more, please repeat the process.`;
export const ROWS_PER_PAGE_LABEL = 'Rows per page:';
export const ERROR_WHILE_FETCHING_SUBSCRIPTIONS = 'Error while fetching API subscriptions: {0}';
export const UNSUBSCRIBE_APIS = 'Unsubscribe APIs';
export const UNSUBSCRIBE_CONFIRMATION = 'Are you sure you want to unsubscribe from';
export const UNSUBSCRIBE_TOPICS = 'Unsubscribe Topics';
export const APIS = 'APIs';
export const CANCEL = 'Cancel';
export const APIS_UNSUBSCRIBED_SUCCESSFULLY = 'APIs unsubscribed successfully';
export const TOPICS_UNSUBSCRIBED_SUCCESSFULLY = 'Topics unsubscribed successfully';
export const UNSUCCESSFUL_TOPIC_UNSUBSCRIBE_MESSAGE = 'Unsubscribe was unsuccessful for the Topics:{0}';
export const UNSUCCESSFUL_UNSUBSCRIBE_TITLE = 'Unsubscribe unsuccessful';
export const UNSUCCESSFUL_UNSUBSCRIBE_MESSAGE = 'Unsubscribe was unsuccessful for these APIs:';
export const UNSUCCESSFUL_UNSUBSCRIBE_MESSAGE_TOPIC = 'Unsubscribe was unsuccessful for these Topics:';
export const SUBSCRIBED_APIS = 'Subscribed APIs';
export const SELECTED_OF = 'selected of';
export const ROTATE_CLIENT_SECRET = 'Rotate Client Secret';
export const TOPICS = 'Topics';
export const ADD_TOPIC = 'Subscribe Topics';
export const SUBSCRIBED_TOPICS = 'Subscribed Topics';
export const DROPDOWN_WIDTH = 250;
export const DROPDOWN_MAX_HEIGHT = 350;
export const TOPICS_EMPTY_HEADER = 'No Topics subscribed yet';
export const TOPICS_EMPTY_TEXT = `Click ${ADD_TOPIC} button to subscribe topics for the machine`;
export const LABELS = {
  GENERAL: 'General',
  SECRETS: 'Secrets',
  ROLES: 'Roles',
  API: 'API',
  REALMS: 'Allowed Realms',
  TOPICS: 'Topics',
  INTERNAL: 'Internal',
  EXTERNAL: 'External',
  TOPIC_NAME: 'Topic Name',
  TOPIC_ACCESS: 'Topic Access'
}
export const secretTypeOptions = {
    CLASSIC: 'Classic',
    MODERN: 'Modern'
}
export const machineDetailsMock = {
    "id": "e31dfd79-3177-46f3-912f-ee36ffb06e5c",
    "clientId": "6c0b6947-b065-43e5-be36-ee686f0eb9ba",
    "displayName": "testMachin13",
    "subjectId": "abd3bd91-8dfe-4000-9a02-4a8787453c8b",
    "createdBy": "420ce4bb-fb58-4db5-ba25-47e8bfc8d93f",
    "updatedBy": "420ce4bb-fb58-4db5-ba25-47e8bfc8d93f",
    "customerId": "825fa2e7-84cc-4da6-a595-b3c556635b7a",
    "customerJpowerId": 7301,
    "realmId": "074f9df9-c2a5-4870-bf4c-df9ee88247cc",
    "isUberRealmClient": false,
    "secrets": [
        {
            "hint": "UPs",
            "expiry": "2027-01-21T12:05:41.892Z",
            "id": "78696e47-060f-4e83-8cc4-1fc063370451",
            "type": "CLASSIC"
        },
        {
            "hint": "KIe",
            "expiry": "2027-01-21T12:07:51.981Z",
            "id": "43ffa500-b6bf-41e4-8073-65a60d36314d",
            "type": "CLASSIC"
        },
        {
            "hint": "IPD",
            "expiry": "2027-01-21T06:39:36.309Z",
            "id": "3c9c00cb-2458-4629-9564-a02834384384",
            "type": "MODERN"
        }
    ],
    "isDefault": false,
    "tags": [],
    "type": "apim",
    "isExternal": false,
    "maxExpiryDays": 365
};